<script setup>
import { onMounted, ref } from "vue";
import { useModal } from "vue-final-modal";
import { useModalsStore } from "@/stores/showModals";
import { faCalendarAlt, faCartPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
library.add(faCalendarAlt, faCartPlus);
const useModalStore = useModalsStore();
import socialModal from "./modalSocial.vue";

// Tipo de modal social
const modalType = ref("");

onMounted(() => {
  // openOfert();
  // openSocial();
});

const clickSmoothScroll = () => {
  const section = document.querySelector("#section-4");
  section.scrollIntoView({ behavior: "smooth" });
};
const { open: openSocial, close: closeSocial } = useModal({
  component: socialModal,
  props: {
    modalType: modalType,
  },
  attrs: {
    onConfirm() {
      closeSocial();
    },
  },
});
const openModalSocial = (type) => {
  console.log("openModalSocial", type);
  modalType.value = type;
  
  // Reset all modal states first
  useModalStore.showModalWhatsapp = false;
  useModalStore.showShopModal = false;
  
  // Then set the appropriate one based on the type
  if (type === 'whatsapp') {
    useModalStore.showModalWhatsapp = true;
  } else if (type === 'shop') {
    useModalStore.showShopModal = true;
  }
  
  console.log(
    "useModalStore.showModalWhatsapp", useModalStore.showModalWhatsapp,
    "useModalStore.showShopModal", useModalStore.showShopModal
  );
  
  openSocial(type);
};
</script>

<template>
  <div>
    <!-- Botón social (Instagram/Facebook) -->
    <div @click="openModalSocial('social')" class="btn-social">
      <div>
        <button class="container-social z-20">
          <img
            src="@/assets/images/icon-foUS-social.png"
            alt="Redes sociales"
            sizes=""
            srcset=""
          />
        </button>
      </div>
    </div>

    <!-- Botón WhatsApp -->
    <div @click="openModalSocial('whatsapp')" class="btn-social-whatsapp">
      <div>
        <button class="container-social flex-col text-xl lg:text-2xl z-20">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M19.05 4.91A9.816 9.816 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-2.65-1.03-5.14-2.9-7.01m-7.01 15.24c-1.48 0-2.93-.4-4.2-1.15l-.3-.18l-3.12.82l.83-3.04l-.2-.31a8.264 8.264 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24c2.2 0 4.27.86 5.82 2.42a8.183 8.183 0 0 1 2.41 5.83c.02 4.54-3.68 8.23-8.22 8.23m4.52-6.16c-.25-.12-1.47-.72-1.69-.81c-.23-.08-.39-.12-.56.12c-.17.25-.64.81-.78.97c-.14.17-.29.19-.54.06c-.25-.12-1.05-.39-1.99-1.23c-.74-.66-1.23-1.47-1.38-1.72c-.14-.25-.02-.38.11-.51c.11-.11.25-.29.37-.43s.17-.25.25-.41c.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31c-.22.25-.86.85-.86 2.07c0 1.22.89 2.4 1.01 2.56c.12.17 1.75 2.67 4.23 3.74c.59.26 1.05.41 1.41.52c.59.19 1.13.16 1.56.1c.48-.07 1.47-.6 1.67-1.18c.21-.58.21-1.07.14-1.18s-.22-.16-.47-.28"
            />
          </svg>
          <span class="text-xs ls:mt-1 font-bold">WhatsApp</span>
        </button>
      </div>
    </div>

    <div @click="openModalSocial('shop')" class="btn-ecommerce">
      <div>
        <button class="container-social flex-col text-xl lg:text-2xl z-20">
          <font-awesome-icon :icon="['fas', 'cart-plus']" />

          <span class="text-xs ls:mt-1 font-bold">Compra en línea</span>
        </button>
      </div>
    </div>

    <!-- Botón Eventos -->
    <div class="btn-ofert z-20 text-center" @click="clickSmoothScroll">
      <div>
        <font-awesome-icon :icon="['fas', 'calendar-alt']" />
        <a class="container-ofert z-50 font-bold">
          <p>Eventos</p>
        </a>
      </div>
    </div>

    <!-- Botón Shop now -->
    <!--    <div class="btn-ofert shop-now z-50" @click="openModalSocial('shop')">
      <div>
        <a class="container-ofert z-50 font-bold">
          <p>Shop now</p>
        </a>
      </div>
    </div> -->
  </div>
</template>

<style scoped>
.container-social {
  display: flex;
  justify-content: center;
  align-items: center;
}
.container-social img {
  width: 80%;
  height: 100%;
}
.container-social:focus {
  outline: none;
}
.container-ofert:focus {
  outline: none;
}
.btn-social {
  position: fixed;

  top: 10%;
  right: 0px;
  z-index: 100;
  width: 5%;
  height: 9%;
  background-color: #f5f5f5;
  border: 1px solid #ffffff;
  border-right: 0px;
  border-radius: 20% 0% 0% 20%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-social:hover {
  color: #ffffff;
  border: 1px solid #000000;
  background-color: #161616;
}

.btn-social:hover img {
  filter: invert(100%);
}

.btn-social-whatsapp {
  position: fixed;

  top: 30%;
  right: 0px;
  z-index: 100;
  width: 5%;
  height: 9%;
  background-color: #f5f5f5;
  border: 1px solid #ffffff;
  border-right: 0px;
  border-radius: 20% 0% 0% 20%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s;
}
.btn-social-whatsapp:hover {
  color: #ffffff;
  border: 1px solid #000000;
  background-color: #161616;
}

.btn-social-whatsapp:hover img {
  filter: invert(100%);
}

.btn-ecommerce {
  position: fixed;
  top: 40%;
  right: 0px;
  z-index: 100;
  width: 5%;
  height: 9%;
  background-color: #f5f5f5;
  border: 1px solid #ffffff;
  border-right: 0px;
  border-radius: 20% 0% 0% 20%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s;
}
.btn-ecommerce:hover {
  color: #ffffff;
  border: 1px solid #000000;
  background-color: #161616;
}

.btn-ecommerce:hover img {
  filter: invert(100%);
}

.btn-ofert {
  position: fixed;
  top: 20%;
  right: 0px;
  z-index: 100;
  width: 5%;
  height: 9%;
  background-color: #f5f5f5;
  border: 1px solid #ffffff;
  border-right: 0px;
  border-radius: 20% 0% 0% 20%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s;
}

.shop-now {
  top: 40%;
}

.btn-ofert:hover {
  background-color: #161616;
  color: #ffffff;
  border: 1px solid #000000;
}
a p {
  font-size: 0.8rem;
  text-align: center;
  padding: 0px;
  margin: 0px;
  line-height: 1;
}

/* Pantallas grandes */
@media (min-width: 1500px) {
  .btn-ofert {
    width: 3.5%;
    height: 6%;
    top: 10%;
  }
  .btn-social {
    width: 3.5%;
    height: 6%;
    top: 20%;
  }
  .shop-now {
    top: 40%;
  }
}
/*Pantallas grandes*/
@media (min-width: 1500px) {
  .btn-social {
    top: 17%;
  }
}

/* PC */
@media (min-width: 992px) and (max-width: 1499px) {
  .shop-now {
    top: 40%;
  }
}

/* Tablet */
@media (min-width: 768px) and (max-width: 991px) {
  .btn-ofert {
    width: 10% !important;
    height: 6%;
    top: 10%;
  }
  .btn-social {
    width: 10% !important;
    height: 6%;
    top: 18%;
  }

  .btn-social-whatsapp {
    width: 10% !important;
    height: 6%;
    top: 26%;
  }
  .btn-ecommerce {
    width: 10% !important;
    height: 6%;
    top: 34%;
  }

  .shop-now {
    width: 10% !important;
    height: 6%;
    top: 34%;
  }

  .container-social img {
    width: 50px;
    height: auto;
  }
}
/* Mobile */
@media (max-width: 767px) {
  .btn-ofert {
    width: 15%;
    height: 6%;
    top: 10%;
  }
  a p {
    font-size: 0.5rem;
  }
  .btn-social {
    width: 15%;
    height: 6%;
    top: 18%;
  }

  .btn-social-whatsapp {
    width: 15%;
    height: 6%;
    top: 26%;
  }
  .btn-ecommerce {
    width: 15%;
    height: 6%;
    top: 34%;
  }

  .shop-now {
    width: 15%;
    height: 6%;
    top: 34%;
  }

  .container-social img {
    width: 40px;
    height: auto;
  }

  .container-social span {
    font-size: 0.6rem;
  }

  .container-social svg {
    font-size: 1.2rem;
  }
}
</style>
